module.exports = __webpack_public_path__ + "static/media/favicon.b1f447b0.png";